import { compose } from 'recompose';
import { withTranslation } from 'react-i18next';
import NotesProject from './notesProject';

const enhance = compose(
  withTranslation(['common', 'tasks']),
);
export default enhance(NotesProject);
